import { request } from "@/utils/request";

const NOTIFICATION_API = "v2/notification";

function notificationRequest(config) {
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("t_k") : "";
  return request({
    ...config,
    headers: {
      ...(config.headers || {}),
      ...(token ? { authorization: token } : {}),
    },
  });
}

export function getNotificationList(params) {
  return notificationRequest({
    url: `${NOTIFICATION_API}/list`,
    method: "get",
    params,
  });
}

export function getNotificationUnreadCount() {
  return notificationRequest({
    url: `${NOTIFICATION_API}/unread-count`,
    method: "get",
  });
}

export function markNotificationAsRead(id) {
  return notificationRequest({
    url: `${NOTIFICATION_API}/${id}/read`,
    method: "post",
  });
}

export function markAllNotificationsAsRead() {
  return notificationRequest({
    url: `${NOTIFICATION_API}/read-all`,
    method: "post",
  });
}

export function deleteNotification(id) {
  return notificationRequest({
    url: `${NOTIFICATION_API}/${id}`,
    method: "delete",
  });
}
